import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const UserDashboardIntakeIntentsModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboardIntakeIntentsModal" */
      './UserDashboardIntakeIntentsModal.dynamic'
    ),
  loading: LoadingModal,
});
